var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.close)?_c('div',{staticClass:"advertisement"},[_c('p',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.clickClose.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-close"})]),_c('img',{attrs:{"src":_vm.wideUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }